/*SYSTEM IMPORTS*/
import React from "react"

import Img from "components/Img"

/*Ui*/
import Link from "components/Link"
import Btn from "components/ui/Btn"
import Cont from "components/ui/Cont"
import DoctorCard, { Experience } from "components/ui/DoctorCard"
import { City } from "components/ui/City"
import Specialty, { SpecialtyItem } from "components/ui/Specialty"
import ActionWrapp from "components/ui/ActionWrapp"
import Rating from "components/ui/Rating"
import DoctorsInsagramLinks from "components/ui/Elements/DoctorsInsagramLinks"

/*Images*/
import BtnIcons from "images/btn-icons.svg"
import InstagramIcon from "images/instagram.svg"

/*HELPERS*/
import { Helpers } from "api"
import { declOfNum } from "helpers/Numbers"
import AppCore from "cores/AppCore"

import "./style"
import "./media"
import { IsArray, IsIsset } from "../../../helpers/ValueTests"

/* CONSTANTS */
import * as AnalyticAction from "constants/AnalyticAction"
import ConnectReduxWith from "helpers/Redux/connectRedux"

@ConnectReduxWith("settings")
class ContDoctorCard extends React.PureComponent {
    prodHost = `https://skin.expert`

    getActionLink = (action = "chat") => {
        const {
            user: { seo_alias },
            has_moderator = false,
            settings: { landing_id },
        } = this.props

        if (has_moderator) {
            action = "moderator"
        }

        return `/doctor/${seo_alias}?action=${action}&landing_id=${landing_id}&from=doctor_landing`
    }

    isDevEnv = () => {
        return (
            window.location.hostname.indexOf("dev") !== -1 ||
            window.location.hostname.indexOf("stage") !== -1
        )
    }

    redirectToAction = (actionUrl) => {
        if (!this.isDevEnv()) {
            window.open(`${this.prodHost}${actionUrl}`, "_blank")
        } else {
            window.open(actionUrl, "_blank")
        }
    }

    handleToChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VRITE_TO_DOCTOR,
            AnalyticAction.MID_BUTTON
        )

        const actionUrl = this.getActionLink("chat")

        this.redirectToAction(actionUrl)
    }

    handleToVideoChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VIDEOCALL_TO_DOCTOR,
            AnalyticAction.MID_BUTTON
        )

        const actionUrl = this.getActionLink("video_chat")

        this.redirectToAction(actionUrl)
    }

    render() {
        const {
            id,
            value: { description = "", display_rating = false, image = [] },
            user: {
                cities = [],
                speciality = [],
                rating = 0,
                experience = 0,
                name = "",
                last_name = "",
                middle_name = "",
                instagram = [],
            },
            allow_video_consultation = 0,
            allow_chat_consultation = 0,
        } = this.props

        const denied_consultation =
            !IsIsset(allow_chat_consultation) &&
            !IsIsset(allow_video_consultation)

        return (
            <Cont className="cont-doctor-card">
                <DoctorCard
                    id={`block-${id}`}
                    name={`${last_name} ${name} ${middle_name}`}
                    photo={
                        <Img
                            src={`${Helpers.GetImage(image[0], "full")}`}
                            externals
                            div
                        />
                    }
                    description={
                        <div
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    }
                >
                    {display_rating && <Rating value={rating} />}

                    {IsIsset(experience) && experience !== 0 && (
                        <Experience
                            value={`${experience} ${declOfNum(
                                parseInt(experience),
                                AppCore.Interfaces.t(
                                    "SpecialWords.Declared.year"
                                ).split("|")
                            )}`}
                        />
                    )}

                    <City value={cities} />

                    {instagram &&
                        IsArray(instagram) &&
                        instagram.length > 0 && (
                            <DoctorsInsagramLinks>
                                {instagram.map((item) => {
                                    return (
                                        <Link
                                            to={`https://www.instagram.com/${item}/`}
                                        >
                                            <Img src={InstagramIcon} />
                                            <span>@{item}</span>
                                        </Link>
                                    )
                                })}
                            </DoctorsInsagramLinks>
                        )}

                    <Specialty>
                        {speciality.map((item) => (
                            <SpecialtyItem key={item.id} value={item.title} />
                        ))}
                    </Specialty>

                    {!denied_consultation && (
                        <ActionWrapp>
                            {allow_chat_consultation == 1 && (
                                <Btn
                                    className="btn-chat"
                                    onClick={this.handleToChat}
                                    image={<Img src={BtnIcons} div />}
                                >
                                    {AppCore.Interfaces.t(
                                        "DoctorLanding.Ui.ContDoctorCard.Index.ButtonWriteInChat"
                                    )}
                                </Btn>
                            )}
                            {allow_video_consultation == 1 && (
                                <Btn
                                    className="btn-video"
                                    onClick={this.handleToVideoChat}
                                    image={<Img src={BtnIcons} div />}
                                >
                                    {AppCore.Interfaces.t(
                                        "DoctorLanding.Ui.ContDoctorCard.Index.ButtonVideoCall"
                                    )}
                                </Btn>
                            )}
                        </ActionWrapp>
                    )}
                </DoctorCard>
            </Cont>
        )
    }
}

export default ContDoctorCard
